import { Component, OnInit, OnDestroy } from '@angular/core';
import { AnimationsService } from '../../services/animations.service';
import { forkJoin, Subject, takeUntil } from 'rxjs';
import { AnimationItemState } from '../../models/animation-item-state-model';
import { TokenizationFlowService } from '../../services/tokenization-flow.service';
import { TokenizationFlowStep } from '../../enums/enums.enum';
import { Globals } from '../../globals';
import { createAnimationProcessItems } from './animation-process.provider';
import { GidLoggerService } from '@copec-gid/gid-arquitectura.console-log';

@Component({
  selector: 'app-animation-page',
  templateUrl: './animation-page.component.html',
  styleUrls: ['./animation-page.component.scss']
})
export class AnimationPageComponent implements OnInit, OnDestroy {
  animations: { [key: string]: AnimationItemState } = createAnimationProcessItems();

  currentAnimation = '';
  currentStep: TokenizationFlowStep = TokenizationFlowStep.IDLE;
  readonly TokenizationFlowStep = TokenizationFlowStep;
  animationsLoaded = false;
  loadedCount = 0;
  totalAnimations = Object.keys(this.animations).length;
  private destroy$ = new Subject<void>();

  constructor(
    private animationsService: AnimationsService,
    private tokenizationFlow: TokenizationFlowService,
    private logger: GidLoggerService
  ) { }

  ngOnInit(): void {
    this.loadAllAnimations();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private loadAllAnimations(): void {
    const animationNames = Object.keys(this.animations);

    forkJoin([
      this.animationsService.loadAnimationJson('card1'),
      this.animationsService.loadAnimationJson('card2'),
      this.animationsService.loadAnimationJson('card3')
    ])
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (results) => {
          animationNames.forEach((name, index) => {
            this.animations[name].data = results[index];
            this.animations[name].loaded = true;
          });

          this.loadedCount = animationNames.length;
          this.animationsLoaded = true;
          this.subscribeToFlow();
        },
        error: (error) => {
          this.logger.error('Error loading animations:', error);
        }
      });
  }

  private playAnimation(name: string): void {
    if (this.animations[name].loaded) {
      this.currentAnimation = name;
      this.animationsService.playAnimation(name);
    }
  }


  submitGoHomeApp(): void {
    Globals.manuallyNavigateTo(`/success`);
  }

  private subscribeToFlow(): void {
    this.tokenizationFlow.flowStep$
    .pipe(takeUntil(this.destroy$))
    .subscribe((step: TokenizationFlowStep) => {
      if (!this.animationsLoaded) return;

      this.currentStep = step;

      if (step === TokenizationFlowStep.AUTHENTICATING) {
        this.playAnimation('card1');
        return;
      }

      if (step === TokenizationFlowStep.ENROLLING) {
        this.playAnimation('card2');
        return;
      }

      if (step === TokenizationFlowStep.SUCCESS) {
        this.playAnimation('card3');
        return;
      }
    });
  }
}